(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-all-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-shopall-grid]').forEach((section) => {
    const buttons = section.querySelectorAll('[data-shopall-filter]');
    const products = section.querySelectorAll('[data-shopall-product]');
    const empty = section.querySelector('.shopall-grid__empty');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.shopallFilter;
        let shown = 0;
        buttons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
        products.forEach((product) => {
          const visible = filter === 'all' || product.dataset.shopallProduct.split(' ').includes(filter);
          product.hidden = !visible;
          if (visible) shown += 1;
        });
        empty.hidden = shown !== 0;
        const list = section.querySelector(".shopall-grid__products");
        if (list) list.scrollLeft = 0;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
